import { CircularProgress } from '@mui/material';

import { ActivityFeed } from 'features/JobActivityFeed/ActivityFeed';
import { ActivityFeedTabProps } from './types';
import { ATSTabbedJobViewActivityFeedTestIds } from 'data-testids/ATS';
import { useQueryGetActivityFeedDataByJobId } from './queries';
import { getAxiosErrorMessageByStatusCode } from 'hooks/errorHandling/errorHandlingHooks';
import { Alert } from 'sharedComponents/Alert';

export const ActivityFeedTab: React.FC<ActivityFeedTabProps> = ({ jobId }) => {
  const { data, isLoading, isError, error } = useQueryGetActivityFeedDataByJobId(jobId);

  const errorMessage = getAxiosErrorMessageByStatusCode(error);

  if (errorMessage) {
    return <Alert type="error">{errorMessage ?? 'Something went wrong'}</Alert>;
  }

  return (
    <>
      {isLoading && !data ? (
        <CircularProgress data-testid={ATSTabbedJobViewActivityFeedTestIds.LOADING_SPINNER} />
      ) : (
        <ActivityFeed
          hasActivity={data?.length > 0}
          hasErrorFetchingActivity={isError}
          isLoading={isLoading}
          allActivity={data}
          dataTestId={ATSTabbedJobViewActivityFeedTestIds.ACTIVITY_FEED}
        />
      )}
    </>
  );
};
